import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Widget, Editable } from '@niche-js/core/components';

var styles = {"container":"niche-js-block-quote-container","body":"niche-js-block-quote-body"};

var propTypes = {
  body: PropTypes.string,
  caption: PropTypes.string,
  className: PropTypes.string
};
var defaultProps = {
  body: null,
  caption: null,
  className: null
};
function Quote(_ref) {
  var body = _ref.body,
    caption = _ref.caption,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(Widget, {
    tag: "figure",
    className: classNames([styles.container, _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement(Editable, {
    tag: "blockquote",
    name: "body",
    className: styles.body,
    html: body,
    placeholder: "Quote"
  }), caption !== null || false ? /*#__PURE__*/React.createElement(Editable, {
    tag: "figcaption",
    name: "caption",
    className: styles.caption,
    html: caption,
    placeholder: "Quote caption",
    inline: true
  }) : null);
}
Quote.propTypes = propTypes;
Quote.defaultProps = defaultProps;

export { Quote as default };
